/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_EvidenceInputs */

const en_cp_mock_evidence = /** @type {(inputs: Cp_Mock_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence ratio`)
};

const id_cp_mock_evidence = /** @type {(inputs: Cp_Mock_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasio bukti`)
};

/**
* | output |
* | --- |
* | "Evidence ratio" |
*
* @param {Cp_Mock_EvidenceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_evidence = /** @type {((inputs?: Cp_Mock_EvidenceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_EvidenceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_evidence(inputs)
	return en_cp_mock_evidence(inputs)
});